import { createTheme } from "@mui/material";

const materialUITheme = createTheme({
    components: {
        MuiCheckbox: {
            styleOverrides: {
              root: {
                color: 'var(--grey-200)',
          
                '&.Mui-checked': {
                  color: 'var(--green-350)',
                },
          
                '&.Mui-disabled': {
                  color: 'var(--grey-300)',
                },
          
                '&.Mui-checked.Mui-disabled': {
                  color: 'var(--grey-400)',
                },
          
                '.MuiSvgIcon-root': {
                  height: '1rem',
                },
              },
            },
          },
          MuiRadio: {
            styleOverrides: {
              root: {
                color: 'var(--grey-200)',
                '& .MuiSvgIcon-root': {
                  fontSize: '1rem', // Reduce el tamaño del círculo
                },
          
                '&.Mui-checked': {
                  color: 'var(--green-350)',
                },
          
                '&.Mui-disabled': {
                  color: 'var(--grey-300)',
                },
          
                '&.Mui-checked.Mui-disabled': {
                  color: 'var(--grey-400)', 
                },
          
                // '.MuiSvgIcon-root': {
                //   height: '1rem',
                // },
              },
            },
          },
          
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    backgroundColor: 'var(--black-mid)',
                    color: 'var(--white)', 
                    fontSize: 'var(--p-size)',
                    textTransform : "capitalize",
                    borderRadius: '.2rem',
                },
                arrow: {
                    color: 'var(--black-mid)', 
                },
            },
        },
    },
});

export default materialUITheme;